import { useGetLineViewAssetsQuery } from 'api';
import { ReactNode } from 'react';
import { ResourceType } from 'types';

interface UseVisualOverviewWidgetProps {
  lineId: string;
}

export const useLineImageWidget = ({
  lineId
}: UseVisualOverviewWidgetProps): {
  isLoading?: boolean;
  isError?: string | boolean;
  [key: string]: unknown;
} => {
  const { data, isLoading, isError } = useGetLineViewAssetsQuery({ assetType: ResourceType.LineImage, lineId });

  return { data, isLoading, isError };
};
